import { render } from "./ExpenseEdit.vue?vue&type=template&id=79c6d5b0"
import script from "./ExpenseEdit.vue?vue&type=script&lang=js"
export * from "./ExpenseEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__